import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { Meditation } from '@/types/meditation';

/**
 * Загружает все треки одной категории по category_id
 * Используется в плеере для навигации между треками
 */
export function useCategoryTracks(categoryId: string | undefined) {
  const [tracks, setTracks] = useState<Meditation[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!categoryId) {
      setTracks([]);
      setLoading(false);
      return;
    }
    (async () => {
      const { data } = await supabase
        .from('meditations')
        .select('*, category:meditation_categories(*)')
        .eq('category_id', categoryId)
        .order('display_order');
      
      if (data) setTracks(data as Meditation[]);
      setLoading(false);
    })();
  }, [categoryId]);

  return { tracks, loading };
}
